"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeComponents = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@blueprintjs/core");
var DateRangeDateTimeSection_1 = require("./DateRangeDateTimeSection");
var DateRangeInputSection_1 = require("./DateRangeInputSection");
var ITypes_1 = require("../type/ITypes");
var DateRangeTimeSection_1 = require("./DateRangeTimeSection");
var styles_1 = require("../styled/styles");
var DateRangeUtils_1 = require("../utils/DateRangeUtils");
var moment_1 = __importDefault(require("moment"));
var react_use_1 = require("react-use");
var Popover = core_1.Popover;
var DateRangeComponents = function (props) {
    var _a, _b, _c, _d;
    var dateType = props.dateType, minTime = props.minTime, maxTime = props.maxTime, shortcuts = props.shortcuts, onShortcutChange = props.onShortcutChange, selectedShortcutIndex = props.selectedShortcutIndex, format = props.format, disabled = props.disabled, state = props.state, onChangeDate = props.onChangeDate, onChangeTime = props.onChangeTime, startTimeProps = props.startTimeProps, endTimeProps = props.endTimeProps, onOpening = props.onOpening, onClosing = props.onClosing, useAmPm = props.useAmPm, precision = props.precision, dayPickerProps = props.dayPickerProps, popoverProps = props.popoverProps, onChangeDateTime = props.onChangeDateTime, allowSingleDayRange = props.allowSingleDayRange, tipLabels = props.tipLabels, upperCaseFormat = props.upperCaseFormat, setUpdateOrder = props.setUpdateOrder, updateOrder = props.updateOrder;
    var _e = (0, react_1.useState)(false), isOpen = _e[0], setOpen = _e[1];
    var _f = DateRangeUtils_1.DateRangeUtils.transformState(state), startTime = _f.startTime, endTime = _f.endTime;
    var isNullDateRangeRef = (0, react_1.useRef)(false);
    var _g = (0, react_1.useState)(core_1.Boundary.START), boundary = _g[0], setBoundary = _g[1];
    var onFocusInputs = function (bound) { return function () {
        setBoundary(bound);
        if (!disabled && !isOpen) {
            setOpen(true);
        }
    }; };
    var onBlurInputs = function (bound) { return function (event) {
        var _a;
        (_a = props.onBlurInputs) === null || _a === void 0 ? void 0 : _a.call(props, bound)(event);
    }; };
    var internalOnShortcutChange = function (shortcut, index) {
        var isNotNullRange = shortcut.dateRange.every(function (it) { return !!it; });
        var newValue = isNotNullRange
            ? shortcut.dateRange
            : [null, null];
        if (shortcut === null || shortcut === void 0 ? void 0 : shortcut.includeTime) {
            onChangeDateTime(newValue);
        }
        else {
            onChangeDate(newValue);
            if (!isNotNullRange) {
                var toDay = (0, moment_1.default)().toDate();
                onChangeTime('START')(DateRangeUtils_1.DateRangeUtils.includeTimeToDate(toDay, 24, 0));
                onChangeTime('END')(DateRangeUtils_1.DateRangeUtils.includeTimeToDate(toDay, 23, 59));
            }
        }
        isNullDateRangeRef.current = true;
        onShortcutChange === null || onShortcutChange === void 0 ? void 0 : onShortcutChange(shortcut, index);
    };
    var onClickInput = function (type) { return function () {
        setBoundary(type);
    }; };
    var handleDateRangePickerChange = function (selectedDates) {
        var startDate = DateRangeUtils_1.DateRangeUtils.transformState(state).startDate;
        var selectedStart = selectedDates[0], selectedEnd = selectedDates[1];
        var nextBoundary = selectedStart &&
            startDate &&
            (0, moment_1.default)(startDate).format('MM/DD/YYYY') ===
                (0, moment_1.default)(selectedStart).format('MM/DD/YYYY')
            ? core_1.Boundary === null || core_1.Boundary === void 0 ? void 0 : core_1.Boundary.START
            : core_1.Boundary.END;
        setBoundary(!selectedStart
            ? core_1.Boundary.START
            : !selectedEnd
                ? core_1.Boundary.END
                : nextBoundary);
        if (selectedStart && selectedEnd) {
            if ((0, moment_1.default)(selectedEnd).diff(selectedStart, 'day') < 1) {
                onChangeDate([selectedEnd, selectedStart]);
                return;
            }
        }
        onChangeDate(selectedDates);
    };
    var ref = (0, react_1.useRef)(null);
    (0, react_use_1.useClickAway)(ref, function () { return setOpen(false); });
    return (react_1.default.createElement(Popover, { minimal: true, enforceFocus: false, interactionKind: core_1.PopoverInteractionKind.HOVER, isOpen: isOpen, onClosing: onClosing, onOpening: onOpening, usePortal: true, position: core_1.Position.BOTTOM_LEFT, autoFocus: false, modifiers: __assign({ preventOverflow: { boundariesElement: 'viewport' } }, popoverProps), shouldReturnFocusOnClose: false, content: react_1.default.createElement("div", { ref: ref }, dateType === 'DATE' || dateType === 'DATETIME' ? (react_1.default.createElement(DateRangeDateTimeSection_1.DateRangeDateTimeSection, { state: state, boundary: boundary, onChangeDate: handleDateRangePickerChange, onChangeTime: onChangeTime, dateType: dateType, shortcuts: shortcuts ? shortcuts : false, onShortcutChange: internalOnShortcutChange, selectedShortcutIndex: selectedShortcutIndex, minTime: minTime, maxTime: maxTime, disabled: disabled, startTimeProps: startTimeProps, endTimeProps: endTimeProps, useAmPm: useAmPm, precision: precision, dayPickerProps: dayPickerProps, allowSingleDayRange: allowSingleDayRange })) : (react_1.default.createElement(styles_1.DateRangeTimeSectionWrapper, null,
            react_1.default.createElement(DateRangeTimeSection_1.DateRangeTimeSection, { startTime: {
                    value: startTime,
                    onChange: onChangeTime('START'),
                    useAmPm: (_a = startTimeProps === null || startTimeProps === void 0 ? void 0 : startTimeProps.useAmPm) !== null && _a !== void 0 ? _a : useAmPm,
                    precision: (_b = startTimeProps === null || startTimeProps === void 0 ? void 0 : startTimeProps.precision) !== null && _b !== void 0 ? _b : precision
                }, endTime: {
                    value: endTime,
                    onChange: onChangeTime('END'),
                    useAmPm: (_c = endTimeProps === null || endTimeProps === void 0 ? void 0 : endTimeProps.useAmPm) !== null && _c !== void 0 ? _c : useAmPm,
                    precision: (_d = endTimeProps === null || endTimeProps === void 0 ? void 0 : endTimeProps.precision) !== null && _d !== void 0 ? _d : precision
                }, disabled: disabled })))) },
        react_1.default.createElement(DateRangeInputSection_1.DateRangeInputSection, __assign({ format: format !== null && format !== void 0 ? format : ITypes_1.DEFAULT_FORMAT, state: state, dateType: dateType, disabled: disabled, onClick: onClickInput, upperCaseFormat: upperCaseFormat, tipLabels: tipLabels, onBlurInputs: onBlurInputs, onFocusInputs: onFocusInputs }, { updateOrder: updateOrder, setUpdateOrder: setUpdateOrder }))));
};
exports.DateRangeComponents = DateRangeComponents;
